import { Form } from 'antd';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Colors, Utils } from '@config';
import { UserSignin } from '@config/Schema';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { AppAction } from '@store/actions';
import ButtonLoader from '@components/Button/ButtonLoader';
import siteLogo from '../../assets/images/logo-text-x.png';
import useColors from '@hooks/useColors';
import TextInput from '@components/form/text-input';
import { ErrorMessage, PasswordInput } from '@components';
import Link from 'antd/es/typography/Link';

const Signin = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loader = useSelector((state) => state?.AppReducer.loader);
    const validCompany = useSelector(
        (state) => state?.AppReducer?.validCompany,
    );
    const companyLogo = Utils.getBrandLogoUrl(validCompany) ?? siteLogo;

    const { colorPrimary } = useColors();

    let schema = UserSignin;
    const { handleSubmit, control } = useForm({
        resolver: yupResolver(schema),
    });

    const getCurrentProfileData = useCallback(() => {
        dispatch(AppAction.GetCurrentUser());
    }, []);

    const signinHandler = (data) => {
        dispatch(
            AppAction.SignIn(
                {
                    ...data,
                    companyUrl:
                        Utils.getCompanyUrlFromHostname() ??
                        window.location.hostname.split('.')[0],
                },
                () => {
                    navigate('/');
                    getCurrentProfileData();
                },
            ),
        );
    };

    const signupRedirectHandler = () => {
        // // to run locally
        // window.location.replace(
        //     `http://app.localhost:${window?.location?.port || '3000'}/onboard-company`,
        // );
        // to run QA
        // QA/STAGING BUILD
        if (window.location.pathname !== '/onboard-company') {
            window.location.replace(Utils.getPublicOnboardingUrl());
            //LIVE BUILD
            // window.location.replace(
            //     'https://app.guardsconnect.com/onboard-company',
            // );
        }
    };

    return (
        <>
            {/* <a href="#" className="mt-3">
                <img
                    className="xl:w-80 md:w-80 xl:h-32 md:h-32 h-24 w-72 mr-2 object-contain"
                    src={validCompany?.logo[0]?.url ?? siteLogo}
                    alt="logo"
                />
            </a> */}
            <div
                className={`rounded-full border border-gray-300 drop-shadow-md w-28 h-28 mx-auto my-4 p-1`}
            >
                <Link>
                    <img
                        // style={{ width: '200px', height: '60px' }}
                        className="mx-auto py-0 object-contain w-full h-full rounded-full"
                        src={companyLogo}
                    />
                </Link>
            </div>
            <div className="w-full md:mt-0 sm:max-w-md xl:p-0">
                <div className="pt-3 mx-auto flex items-center flex-col justify-center">
                    <p
                        className="text-center text-sm font-medium mb-5 max-w-[44ch]"
                        style={{ color: Colors.Gray }}
                    >
                        Guards Connect, Inc. is located in the heart of the
                        Enchanted Mountains, We are your local Guard,
                    </p>

                    <Form
                        onFinish={handleSubmit(signinHandler)}
                        className="space-y-4 w-full"
                        style={{}}
                    >
                        <div>
                            <Controller
                                name="email"
                                control={control}
                                render={({ field, fieldState }) => {
                                    return (
                                        <>
                                            <TextInput
                                                {...field}
                                                placeholder="Email Address"
                                            />
                                            {fieldState?.error && (
                                                <ErrorMessage>
                                                    {fieldState?.error.message}
                                                </ErrorMessage>
                                            )}
                                        </>
                                    );
                                }}
                            />
                        </div>
                        <div>
                            <Controller
                                name="password"
                                control={control}
                                render={({
                                    field: { value, onChange },
                                    fieldState,
                                }) => {
                                    return (
                                        <div>
                                            <PasswordInput
                                                value={value}
                                                onChange={onChange}
                                                placeholder="Password"
                                            />
                                            {fieldState?.error && (
                                                <ErrorMessage>
                                                    {fieldState?.error.message}
                                                </ErrorMessage>
                                            )}
                                        </div>
                                    );
                                }}
                            />
                        </div>

                        <div className="flex items-center justify-end">
                            <a
                                href="#"
                                className="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500"
                                style={{ color: Colors.Black }}
                                onClick={() => navigate('/forgot-password')}
                            >
                                Forgot password?
                            </a>
                        </div>
                        <ButtonLoader
                            style={{
                                backgroundColor: colorPrimary,
                                boxShadow: `box-shadow: 0px 10px 30px ${colorPrimary};`,
                            }}
                            loader={loader}
                            text="Login"
                            className="cursor-pointer w-full focus:ring-4 focus:outline-none font-medium rounded-full text-sm text-center h-12 text-base tracking-wider"
                        />
                    </Form>

                    <p className="flex items-center justify-end text-sm font-medium text-primary-600 mt-2">
                        Don't have an account?{' '}
                        <span
                            onClick={signupRedirectHandler}
                            className="ml-1 cursor-pointer"
                            style={{ color: colorPrimary }}
                        >
                            Sign Up
                        </span>
                        {/* <Link href="/onboard-company" className='ml-1'></Link> */}
                    </p>
                    <p className="text-xs text-center mt-6">
                        Copyright 2025 <Link>GuardsConnect</Link>
                    </p>
                </div>
            </div>
        </>
    );
};

export default Signin;
